import React from 'react';
import ImageThumbnail from './ImageThumbnail';
import TextField from '../form/TextField';
import { DeleteIcon } from '../IconIndex';
import IconButton from '@mui/material/IconButton';

export default ({ photo, onClickRemoveAction, onClickOpenImage }) => {
    return (
        <div className="uploaded-image-details">
            <div
                role={!!onClickOpenImage && 'button'}
                className={!!onClickOpenImage && 'hasClick'}
                onClick={() => !!onClickOpenImage && onClickOpenImage()}
            >
                <ImageThumbnail image={photo.File.AbsoluteLink} productTitle={photo.File.Name} />
            </div>

            {!!photo.Caption && <TextField label="Captions" value={photo.Caption} readOnly />}
            {!!photo.Comment && <TextField label="Comments" value={photo.Comment} readOnly />}
            {onClickRemoveAction && (
                <div style={{ position: 'absolute', bottom: 32, right: -4 }}>
                    <IconButton title="Remove image" color="secondary" onClick={() => onClickRemoveAction()} size="large">
                        <DeleteIcon />
                    </IconButton>
                </div>
            )}
        </div>
    );
};
